/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Ref } from "react";
import { TextField } from "@material-ui/core";
import { noop } from "../../../../globalConsts";

type UncontrolledOnlyProps = { value?: undefined; defaultValue: string };
type ControlledOnlyProps = { value: string; defaultValue?: undefined };

type Props = (UncontrolledOnlyProps | ControlledOnlyProps) & {
  name?: string;
  onChange?: (v: string) => void;
  onBlur?(): void;
  required?: boolean;
  inputRef?: Ref<any>;
  id?: string;
};

const FlowioHiddenInput: FC<Props> = ({
  value,
  defaultValue,
  inputRef,
  onChange = noop,
  onBlur,
  required,
  name,
  id,
}) => (
  <TextField
    type="hidden"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onBlur={onBlur}
    defaultValue={defaultValue}
    inputRef={inputRef}
    required={required}
    name={name}
    id={id}
    InputProps={{ inputProps: { "data-cy": "input flowio-hidden-input" } }}
  />
);

export default FlowioHiddenInput;
export type FlowioHiddenInputProps = Props;
